import React from "react";
import { Button, Card } from "antd";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import { useState, useEffect } from "react";
import API from "api/endpoints";
import { useNavigate, useParams } from "react-router-dom";
import { formatDateTime } from "Common/DateTimeFormat";
import axiosInstance from "api/axiosInstance";
import {
  ComplaintStatusEnum,
  ComplaintStatusLabel,
} from "Constants/Enums/Complaint/ComplaintStatusEnum";

function EmployeeComplaintDetail() {
  const { complaintId } = useParams();
  const navigate = useNavigate();
  const [complaintDetail, setComplaintDetail] = useState(null);

  useEffect(() => {
    async function fetchComplaintDetail() {
      try {
        const response = await axiosInstance.get(API.complaint.getComplaint(complaintId));
        setComplaintDetail(response.data);
      } catch (error) {
        console.error("Error fetching employee detail:", error);
      }
    }

    fetchComplaintDetail();
  }, []);

  const back = () => {
    navigate("/employeedashboard/complaints");
  };

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <br></br>
        <br></br>
        <div className="body flex-grow-1 px-3">
          <div className="row">
            <Card
              className="card-professional"
              title="Complaint Details"
              extra={
                <Button type="default" onClick={back}>
                  Back
                </Button>
              }
            >
              {complaintDetail && (
                <>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">First Name </h6>
                    <span className="h6-complaint">{complaintDetail.complainantFirstName}</span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Last Name </h6>
                    <span className="h6-complaint">{complaintDetail.complainantLastName}</span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint"> Email </h6>
                    <span className="h6-complaint">{complaintDetail.complainantEmail}</span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Phone No </h6>
                    <span className="h6-complaint">{complaintDetail.complainantPhone}</span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Complaint Name </h6>
                    <span className="h6-complaint">{complaintDetail.complaintTypeName}</span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Complaint Against</h6>
                    <span className="h6-complaint">
                      {complaintDetail.complaintAgainstFirstName} {"  "}
                      {complaintDetail.complaintAgainstLastName}
                    </span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Status</h6>
                    <span className="h6-complaint">
                      {" "}
                      {ComplaintStatusLabel[complaintDetail.status] ?? "Unknown"}
                    </span>
                  </div>
                  <div className="complaint-card mb-2">
                    <h6 className="h6-complaint">Requested Date</h6>
                    <span className="h6-complaint">
                      {formatDateTime(complaintDetail.createdOn)}
                    </span>
                  </div>
                </>
              )}
            </Card>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default EmployeeComplaintDetail;
